import autosize from 'autosize'

export function init (form)
{
	input(form)
	textarea(form)
	checkbox(form)
	select(form)
	file(form)
}

export function input (form)
{
	const inputs = form.querySelectorAll('input, textarea')
	
	inputs.forEach(el =>
	{
		el.addEventListener('focus', () =>
		{
			el.parentElement.classList.add('focused')
		})
		
		el.addEventListener('blur', () =>
		{
			el.parentElement.classList.remove('focused')
		})
		
		el.addEventListener('input', () =>
		{
			if (el.value.trim() !== '')
			{
				el.parentElement.classList.add('filled')
			}
			else
			{
				el.parentElement.classList.remove('filled')
			}
		})
	})
}

export function textarea (form)
{
	const textareas = form.querySelectorAll('textarea')
	
	autosize(textareas)
}

export function checkbox (form)
{
	const checkboxes = form.querySelectorAll('input[type="checkbox"]')
	
	checkboxes.forEach(el =>
	{
		const div = document.createElement('div')
		div.classList.add('checkbox')
		
		el.insertAdjacentElement('afterend', div)
	})
}

export function select (form)
{
	const selects = form.querySelectorAll('select')
	
	selects.forEach(el =>
	{
		//el.style.display = 'none'
		
		const options = el.options
		const value = options[el.selectedIndex].text
		
		if (!options.length)
		{
			return
		}
		
		const domSelect = document.createElement('div')
		domSelect.className = 'select'
		domSelect.innerHTML = `
			<div class="value">${value}</div>
			<div class="options"></div>
		`
		
		Array.from(options).forEach(opt =>
		{
			const domOption = document.createElement('div')
			domOption.className = 'option'
			domOption.dataset.value = opt.value
			domOption.innerHTML = opt.text
			
			domSelect.querySelector('.options').insertAdjacentElement('beforeend', domOption)
		})
		
		el.insertAdjacentElement('afterend', domSelect)
		
		const domOptionsContainer = domSelect.querySelectorAll('.options')
		const domOptions = domOptionsContainer[0].querySelectorAll('.option')
		
		domOptions[0].classList.add('selected')
		
		document.addEventListener('click', (e) =>
		{
			if (e.target !== domSelect.querySelector('.value'))
			{
				domSelect.classList.remove('open')
			}
		})
		
		domSelect.querySelector('.value').addEventListener('click', (e) =>
		{
			domSelect.classList.toggle('open')
		})
		
		domOptions.forEach(opt =>
		{
			opt.addEventListener('click', (e) =>
			{
				const selected = domOptionsContainer[0].querySelector('.selected')
				
				if (selected)
				{
					selected.classList.remove('selected')
				}
				
				opt.classList.add('selected')
				el.selectedIndex = Array.from(domOptions).indexOf(opt)
				el.dispatchEvent(new Event('change'))
				
				domSelect.querySelector('.value').innerHTML = opt.textContent
				domSelect.classList.remove('open')
			})
		})
	})
}

export function file (form)
{
	const files = form.querySelectorAll('input[type="file"]')
	
	files.forEach(el =>
	{
		//el.style.display = 'none'
		
		const domFile = document.createElement('div')
		domFile.className = 'file'
		domFile.innerHTML = `
			<div class="file-name">
				<input type="text" placeholder="Aucun fichier sélectionné" readonly>
			</div>
			<div class="file-select">
				<button type="button" class="button">Ajouter mon CV</button>
			</div>
		`
		
		el.insertAdjacentElement('afterend', domFile)
		domFile.insertAdjacentElement('afterbegin', el)
		
		const fileName = domFile.querySelector('.file-name input')
		const fileSelect = domFile.querySelector('.file-select button')
		
		fileName.addEventListener('click', () =>
		{
			el.click()
		})
		
		fileSelect.addEventListener('click', () =>
		{
			el.click()
		})
		
		el.addEventListener('change', (e) =>
		{
			fileName.value = e.target.files.length ? e.target.files[0].name : ''
		})
	})
}

export function disable (form, disable = true)
{
	const fields = form.querySelectorAll('input, textarea, select, button')
	
	fields.forEach(el =>
	{
		el.disabled = disable
	})
}

export function validate (field, value, context = '')
{
	let el
	
	if (context === 'inline')
	{
		el = field
	}
	else
	{
		el = {
			name: field.name,
			type: field.dataset.type,
			label: field.dataset.label,
			required: field.dataset.required
		}
	}
	
	if (!el.required && value.trim() === '')
	{
		return {
			error: false
		}
	}
	
	if (el.required && value.trim() === '')
	{
		return {
			error: true,
			message: `Veuillez remplir le champ <span>${el.label}</span>`
		}
	}
	
	let validate
	
	switch (el.type)
	{
		case 'email':
			validate = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
			
			if (!validate)
			{
				return {
					error: true,
					message: `Le champ <span>${el.label}</span> n'est pas une adresse email valide`
				}
			}
			
			break
		case 'phone':
			validate = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/.test(value)
			
			if (!validate)
			{
				return {
					error: true,
					message: `Le champ <span>${el.label}</span> n'est pas un numéro de téléphone valide`
				}
			}
			
			break
		case 'url':
			validate = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(value)
			
			if (!validate)
			{
				return {
					error: true,
					message: `Le champ <span>${el.label}</span> n'est pas un lien valide`
				}
			}
			
			break
	}
	
	return {
		error: false
	}
}
